<!-- 商家发布页面 -->
<template>
  <div class="merchantPublishing">
    <div class="head-area clr">
      <div class="fl clr left-search">
        <div class="fl search-item">
          <div class="fl head-label-area">活动名称</div>
          <Input class="fl" v-model="activityName" placeholder="活动名称" clearable style="width:200px"></Input>
        </div>
        <div class="fl search-item">
          <div class="fl head-label-area">活动商家</div>
          <Input class="fl" v-model="merchantName" placeholder="商家名称" clearable style="width:200px"></Input>
        </div>
        <div class="fl search-item">
          <div class="fl head-label-area">发布时间</div>
          <DatePicker
            v-model="createDate"
            format="yyyy-MM-dd HH:mm:ss"
            type="daterange"
            placement="bottom-end"
            placeholder="起止日期"
            style="width: 200px"
            :options="dateOptions"
          ></DatePicker>
        </div>
        <div class="fl search-item">
          <div class="fl head-label-area">活动时间</div>
          <DatePicker
            v-model="activeDate"
            format="yyyy-MM-dd HH:mm:ss"
            type="daterange"
            placement="bottom-start"
            placeholder="起止日期"
            style="width: 200px"
            :options="dateOptions"
          ></DatePicker>
        </div>
        <div class="fl search-item">
          <div class="fl head-label-area">发布状态</div>
          <Select v-model="publishStatus" style="width:200px" clearable>
            <Option
              v-for="item in stateList"
              :value="item.dicCode"
              :key="item.dicCode"
            >{{ item.dicName }}</Option>
          </Select>
        </div>
      </div>
      <div class="fr right-search-btn">
        <Button type="primary" style="margin:0 0 10px;" icon="ios-search" @click="search">查询</Button>
        <Button @click="reset" icon="ios-refresh">重置</Button>
      </div>
    </div>
    <div class="table-area">
      <Table :columns="columns" :data="dataList" size="small" :height="tableHeight">
        <template slot-scope="{ row }" slot="action">
          <a @click="check(row)" style="margin-right:10px">查看</a>
        </template>
      </Table>
    </div>
    <div class="page-area" v-if="dataList.length">
      <Page
        :total="total"
        :current="current"
        :page-size="size"
        show-total
        show-sizer
        :page-size-opts="[20, 50, 100, 500, 1000]"
        @on-change="pageChace"
        @on-page-size-change="pageSizeChace"
      ></Page>
    </div>
    <!-- <div class="packageManagement" v-if="comboManagementShow">
      <comboManagement
        @back="comboManagementShow = false"
        :storeId="currentData.id"
        v-if="comboManagementShow"
      />
    </div>-->

  <!-- 详情弹窗 -->
  <Modal 
    v-model="detailModal.show" 
    title="活动详情" 
    width="800"
    :mask-closable="false"
    @on-cancel="closeDetailModal"
  >
    <div v-if="detailModal.data" class="detail-content">
      <Form :label-width="100">
        <Row :gutter="24">
          <Col span="12">
            <FormItem label="活动名称：">
              <span>{{ detailModal.data.activityName || '-' }}</span>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="商家名称：">
              <span>{{ detailModal.data.merchantName || '-' }}</span>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="24">
          <Col span="12">
            <FormItem label="发布时间：">
              <span>{{ detailModal.data.publishTime || '-' }}</span>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="活动时间：">
              <span>{{ detailModal.data.startTime || '-' }} 至 {{ detailModal.data.endTime || '-' }}</span>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="24">
          <Col span="12">
            <FormItem label="套餐价格：">
              <span>¥{{ detailModal.data.packagePrice || 0 }}</span>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="活动人数：">
              <span>{{ detailModal.data.peopleNum || 0 }}</span>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="24">
          <Col span="12">
            <FormItem label="发布状态：">
              <span>{{ getPublishStatusName(detailModal.data.publishStatus) || '-' }}</span>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="拼团ID：">
              <span>{{ detailModal.data.groupPurchaseId || '-' }}</span>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </div>
    <div slot="footer">
      <Button @click="closeDetailModal">关闭</Button>
    </div>
  </Modal>
  </div>
</template>

<script>

import { getStoreActivityDataList } from '@/api/activityCenter.js'

export default {
  components: {
  },
  data() {
    return {
      activityName: '',
      merchantName: '',
      publishStatus: '',
      createDate: [],
      activeDate: [],
      dateOptions: {
        shortcuts: [
          {
            text: '本周',
            value () {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              return [start, end]
            }
          },
          {
            text: '本月',
            value () {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              return [start, end]
            }
          },
          {
            text: '上个月',
            value () {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 * 1)
              return [start, end]
            }
          }
        ]
      },
      stateList: [
        {
          dicCode: '1',
          dicName: "已发布"
        },
        {
          dicCode: '2',
          dicName: "未发布"
        },
        {
          dicCode: '3',
          dicName: "已取消"
        },
        {
          dicCode: '4',
          dicName: "已完成"
        }
      ],
      tableHeight: window.innerHeight - 330,
      total: 0,
      current: 1,
      size: 20,
      columns: [
        {
          title: '活动名称',
          key: 'activityName',
          ellipsis: true,
          tooltip: true,
        },
        {
          title: '商家名称',
          key: 'merchantName',
          ellipsis: true,
          tooltip: true,
        },
        {
          title: '发布时间',
          key: 'publishTime',
          ellipsis: true,
          tooltip: true,
        },
        {
          title: '活动时间',
          key: 'startTime',
          width: 300,
          render: (h, params) => {
            const startTime = params.row.startTime || '';
            const endTime = params.row.endTime || '';
            if (startTime && endTime) {
              return h('span', {}, `${startTime} 至 ${endTime}`);
            }
            return h('span', {}, startTime + endTime);
          }
        },
        {
          title: '套餐价格',
          key: 'packagePrice',
          width: 120,
        },
        {
          title: '活动人数',
          width: 120,
          key: 'peopleNum',
        },
        {
          title: '发布状态',
          key: 'publishStatus',
          render: (h, params) => {
            const status = this.stateList.find(item => item.dicCode === params.row.publishStatus);
            return h('span', {}, status ? status.dicName : params.row.publishStatus);
          }
        },
        {
          title: '操作',
          width: 130,
          slot: 'action',
        },
      ],
      dataList: [],
      detailModal: {
        show: false,
        data: null
      },
    };
  },
  created() {
    this.findPageDataList()
  },
  methods: {
    reset() {
      this.activityName = ''
      this.merchantName = ''
      this.publishStatus = ''
      this.createDate = []
      this.activeDate = []
      this.search()
    },
    search() {
      this.current = 1
      this.findPageDataList()
    },
    findPageDataList() {
      let params = {
        pageIndex: this.current,
        pageSize: this.size
      }
      
      if (this.activityName) {
        params.activityName = this.activityName
      }
      if (this.merchantName) {
        params.merchantName = this.merchantName
      }
      if (this.publishStatus) {
        params.publishStatus = this.publishStatus
      }
      if (this.createDate && this.createDate.length > 0) {
        params.startTime = this.formatDate(this.createDate[0])
        params.endTime = this.formatDate(this.createDate[1])
      }
      if (this.activeDate && this.activeDate.length > 0) {
        params.activeStartTime = this.formatDate(this.activeDate[0])
        params.activeEndTime = this.formatDate(this.activeDate[1])
      }
      
      getStoreActivityDataList(params).then(res => {
        if (res.success) {
          this.dataList = res.result.list
          this.total = res.result.total
        }
      })
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    check(row) {
      this.detailModal.data = row;
      this.detailModal.show = true;
    },
    del(row) {
      this.$Modal.confirm({
        title: "确认删除？",
        onOk: () => {
          console.log(row)
          //   delStore({ id: row.id }).then(res => {
          //     if (res.success) {
          //       this.$Message.success('删除成功！')
          //       this.findPageDataList()
          //     }
          //   });
        },
      })
    },
    pageChace(page) {
      this.current = page
      this.findPageDataList()
    },
    pageSizeChace(size) {
      this.size = size
      this.findPageDataList()
    },
    closeDetailModal() {
      this.detailModal.show = false;
      this.detailModal.data = null;
    },
    getPublishStatusName(statusCode) {
      const status = this.stateList.find(item => item.dicCode === statusCode);
      return status ? status.dicName : statusCode;
    }
  }
}

</script>
<style lang='scss' scoped>
.merchantPublishing {
  .left-search {
    width: calc(100% - 100px);
    .search-item {
      margin-bottom: 10px;
    }
  }
  .right-search-btn {
    width: 100px;
    border-left: 1px solid #e5e6eb;
    padding-left: 20px;
  }
  .head-label-area {
    line-height: 36px;
    // width: 120px;
    margin-left: 10px;
    padding-right: 15px;
    text-align: right;
  }
  
  .detail-content {
    max-height: 500px;
    overflow-y: auto;
    padding: 10px;
    
    .info-item {
      display: flex;
      margin-bottom: 15px;
      padding-bottom: 15px;
      border-bottom: 1px solid #eee;
      flex-wrap: wrap;
      
      .info-label {
        font-weight: bold;
        color: #666;
        min-width: 100px;
        flex: 0 0 120px;
      }
      
      .info-value {
        color: #333;
        flex: 1;
        word-break: break-word;
      }
    }
  }
}
</style>